import {
    OBTENER_LOGS,    
    ACTUALIZAR_LOG,
    LOG_ERROR,
    LOG_OK,
    LOG_ACTUAL,
    OBTENER_LOG,
    OBTENER_CANTIDAD_ALERTAS
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_LOGS:
            return {
                ...state,
                logs: action.payload
            }
        case OBTENER_CANTIDAD_ALERTAS:
            return {
                ...state,
                eventos: action.payload
            }
        case LOG_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case LOG_OK:
        return {
            ...state,
            mensaje: action.payload
        }      
        case LOG_ACTUAL:
            return {
                ...state,
                log: state.logs.find(l => l._id === action.payload)
            }        
        case ACTUALIZAR_LOG:
            return {
                ...state,
                logs: state.logs.map(l => l._id === action.payload._id ? action.payload : l),
                log: action.payload
            }
        case OBTENER_LOG:
            return {
                ...state,
                log: action.payload
            }
        default:
            return state;
    }
}